
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { UserDairyResult } from '@xt/client/entities/content/types'

type SummDairyCardData = {
  cover: string
  title: string
  content: string
  collect: number
  comment: number
  like: number
}

@Component({
  components: {
    LazyImg
  }
})
export default class SummDairyCard extends Vue {
  @Prop() dataSource: UserDairyResult

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
